export default "__VITE_ASSET__BHD3img$__"